let api = {
};

//登录
api.login = '/api/login';
api.changepassword = '/api/changepassword';

//用户
api.user = {
    list:'/api/user',
    current:'/api/user/info/current',
    findbydept:'/api/user/findByDept/',
	findbyZyCd:'/api/user/getUserByZyCd',
	checkedSave:'/api/user/checkedSave',
	resetPassword:'/api/user/resetPassword',
};

//角色
api.role = {
    list:'/api/role',
	checkedSave:'/api/role/checkedSave',
};

//菜单
api.menu = {
    list:'/api/menu',
    role:'/api/menu/role/'
};

//部门
api.dept = {
    list:'/api/dept',
    findbyplant:'/api/dept/plant/'
};

//工厂
api.plant = {
    list:'/api/plant',
};

//工序
api.process = {
    list:'/api/process',
    findbydept:'/api/process/dept/'
};

// 设备
api.equipment = {
    list:'/api/equipment',
    findbyprocess:'/api/equipment/process/'
};

// 设备类型
api.equipmentType = {
    list:'/api/equipmenttype',
};

// 设备部位
api.equipmentPart = {
    list:'/api/equipmentpart',
};

//字典
api.config = {
    list:'/api/config',
    type:'/api/config/type',
};

//配置
api.sysSetting = {
    type:'/api/sysconfig/type',
    list:'/api/sysconfig'
};



//周期
api.cycle = {
    list:'/api/cycle',
};

//信号灯
api.signal = {
    list:'/api/signal',
    findByPlantId:'/api/signal/config/',
};

//工具
api.tool = {
    list:'/api/tool',
};

//工具
api.tool = {
    list:'/api/tool',
};

// 设备运维
api.equipOpt = {
    list:'/api/equipmatain',
};

// 点检项目
api.check = {
    list:'/api/check', // 点检概要
    part:'/api/checkpart',// 部位
    manual:'/api/checkmanual',
    content:'/api/checkpartcontent',
    contentSelect:'/api/checkpartselect',
};
// 点检组
api.checkGroup = {
    list:'/api/checkgroup',
};

// 故障部位
api.equipTrouble = {
    list:'/api/equiptrouble',
};

// 故障状态
api.equipTroubleStatus = {
    list:'/api/equiptroublestatus',
};

// 故障项目
api.trouble = {
    list:'/api/trouble',
};

// 设备参数
api.equipParameter = {
    list:'/api/equipmentparameter',
};

// 点检计划
api.checkPlan = {
    list:'/api/equipCheckPlan',
};

// 点检计划日历
api.planCalendar = {
    list:'/api/equipCheckPlan/calendar/all',
    edit:'/api/equipCheckPlan/calendar/edit',
    stop:'/api/equipCheckPlan/calendar/stop',
    delete:'/api/equipCheckPlan/calendar/delete',
};

// 维修
api.repair = {
    list:'/api/repair',
    act:'/api/repairact',
};

// 点检实际
api.checkAct = {
    list:'/api/equipact',
    content:'/api/equipact/plan',
    hand:'/api/equipact/hand',
    distribute:'/api/equipact/distribute',
};


// 点检计划日视图
api.checkPlanDay = {
    list:'/api/equipCheckPlan/day/list',
};


// 开工率设定
api.optRate = {
    list:'api/opeartionRate',
    apply:'/api/opeartionRate/apply',
};

// 仪表盘
api.dashboard = {
    equipment:'api/dashboard/equipment',
    list:'api/dashboard',
	// SDNAPS API
	gradestock:'api/dashboard/gradestock',
	stockByQuality:'api/dashboard/stockByQuality',
	stockByWarehouse:'api/dashboard/stockByWarehouse',
	planVsFillin: 'api/dashboard/planVsFillin',
	getTotalStock: 'api/dashboard/getTotalStock',
};

// 设备甘特图
api.equipBoard = {
    list:'/api/history/board',
};

// 设备状态
api.equipRealStatus = {
    list:'/api/history/list',
    export:'/api/history/list/export',
	detail:'/api/history/list/detail'
};

// 设备图表
api.equipBar = {
    list:'/api/dashboard/equipment/date',
};


//设备kpi
api.equipKpi = {
    list:'/api/dashboard/equipment/detail',
	export:'/api/dashboard/equipment/detail/export'
};

//设备kpi
api.equipReport = {
    list:'/api/dashboard/equipment/date/page/d',
    export:'/api/dashboard/equipment/date/export/d',
};
/**
 * 可视化整合
 * @type {{split: string, list: string}}
 */
//国家代码(Common使用)
api.country = {
	countrylist:'/api/country/List',////国家代码
	//工艺步骤
	rtglist:'/api/country/rtgList',
	//机台列表By rtg
	oprlist:'/api/country/oprList',
	//所有机台列表
	oprAllList:'/api/country/oprAllList',
};

//oracle用户列表
api.skspUser = {
	skspUserList:'/api/skspUser/skspUserList',
};
//单位列表
api.unit = {
	unitList:'/api/unit/unitList',
};

// 计划分解
api.planSplit = {
	list:'/api/plan/planList',
	split:'/api/plan/planSplit',

};
// 计划调整
api.planAdjust = {
	list:'/api/planAdjust/planAdjustList',
	stepList:'/api/planAdjust/getStepList',
	export:'/api/export/exportPlanList',
	planConfirm:'/api/planAdjust/planConfirmList',
	planRelieve:'/api/planAdjust/planRelieveList',
	save:'/api/planAdjust/savePlanList',
};

// 机台实绩一览
api.reality = {
	//机台实绩列表
	realityList:'/api/reality/realityList',
	//时间修正
	timeList:'/api/realityTime/timeList',
	timeSave:'/api/realityTime/timeSave',
	timeDelete:'/api/realityTime/timeDelete',
	//数量修正
	numList:'/api/realityNum/numList',
	numSave:'/api/realityNum/numSave',
	numDelete:'/api/realityNum/numDelete',

};
//进度查询
api.progress = {
	list:'/api/progress/progressList',
};

// 现场看板
api.spectaulars = {
	list:'/api/spectaulars/spectaularsList',
};
//机台作业列表查询
api.worklist = {
	list:'/api/worklist/workList',
	//实绩报工
	detail:'/api/worklist/recWork',
	//开始
	start:'/api/worklist/start',
	//暂停
	pause:'/api/worklist/pause',
	//暂停复原
	pauseStart:'/api/worklist/pauseStart',
	//结束
	end:'/api/worklist/end',
	//实绩登录
	saveNum:'/api/worklist/saveNum',
};

// 暂停维护
api.pauser = {
	list:'/api/pauser',
	allList:'/api/pauser/getAllList',
};

// 不良履历
api.dfhistory = {
	getlist:'/api/dfhistory/List',
	list:'/api/dfhistory',
};

//生产计划
api.vPowderPlanDetail= {
	list:'/api/vPowderPlanDetail/vPowderPlanDetailList',
	confirm:'/api/vPowderPlanDetail/confirmPowderPlan',
	getConfirmFlg:'/api/vPowderPlanDetail/getConfirmFlg',
	thisMonthPlanExport:'/api/vPowderPlanDetail/thisMonthPlanExport',
	nextMonthPlanExport:'/api/vPowderPlanDetail/nextMonthPlanExport',
	powderPlanImport:'/api/vPowderPlanDetail/powderPlanImport',

};

//计划分配明细
api.vRollerPlanDetail= {
	list:'/api/vRollerPlanDetail/vRollerPlanDetailList',
	toSavePowderRoller:'/api/vRollerPlanDetail/savePowderRoller',
	toDeletePowder:'/api/vRollerPlanDetail/deletePowder',
	toDeleteRoller:'/api/vRollerPlanDetail/deleteRoller',
	detail:'/api/vDeliveryPlanWa/rollerDetail',
};

// //粉分配明细
// api.vPowderPlanDetail= {
// 	list:'/api/vPowderPlanDetail/vPowderPlanDetailList',
// };
//粉分配状态
api.vPowderStatus= {
	list:'/api/vPowderStatus',
	getlist:'/api/vPowderStatus/vPowderStatusList',
};


//周间出荷
api.vDeliveryPlanW= {
	list:'/api/vDeliveryPlanW/vDeliveryPlanWList',
	PlanSave:'/api/vDeliveryPlanW/planSave',
	PlanDelete:'/api/vDeliveryPlanW/planDelete',
	PlanImport:'/api/vDeliveryPlanW/planImport',
	PlanExport:'/api/vDeliveryPlanW/planExport',
	setLimitDate:'/api/vDeliveryPlanW/setLimitDate',
	gradeDelete:'/api/vDeliveryPlanW/gradeDelete',
};

//出货分配一览
api.vDeliveryPlanWa= {
	list:'/api/vDeliveryPlanWa/vDeliveryPlanWaList',
	PlanExport:'/api/vDeliveryPlanWa/planExport',
};

//成品分配明细
api.vRollerDetail= {
	list:'/api/vRollerDetail/vRollerDetailList',
};

//螺杆尺寸维护
api.tGradeRoller= {
	getlist:'/api/tGradeRoller/tGradeRollerList',
	list:'/api/tGradeRoller',
	upload:'/api/tGradeRoller/upload',
};
//产线管理
api.mEquipmentLine= {
	getlist:'/api/mEquipmentLine/mEquipmentLineList',
	getListNoPage:'/api/mEquipmentLine/mEquipmentLineListNoPage',
	list:'/api/mEquipmentLine',
};
//Grade Group
api.tGradeGroup= {
	list:'/api/tGradeGroup/tGradeGroupList',
	save:'/api/tGradeGroup/groupSave',
	delete:'/api/tGradeGroup/groupDelete',
	import:'/api/tGradeGroup/groupImport',
	export:'/api/tGradeGroup/groupExport',
};

api.vCmBanciAll={
	list:'/api/vCmBanciAll/getAllBan',
};

api.stWebProdAll= {
	inputInstNo:'/api/stWebProdAll/inputInstNo',
	changeLineCd:'/api/stWebProdAll/changeLineCd',
	workSubmit:'/api/stWebProdAll/workSubmit',
	inputItmCd:'/api/stWebProdAll/inputItmCd',
	getProdSeq:'/api/stWebProdAll/getProdSeq',
};

api.vStWebProdAll= {
	list:'/api/vStWebProdAll',
	getList:'/api/vStWebProdAll/vStWebProdAllList',
	checkedSave:'/api/vStWebProdAll/checkedSave',
	toExport:'/api/vStWebProdAll/toExport',
};
api.stWebZyuserAll= {
	getList:'/api/stWebZyuserAll/stWebZyuserAllList',
};
api.stWebZyuserAllTemp= {
	getList:'/api/stWebZyuserAllTemp/stWebZyuserAllTempList',
	checkedDelete:'/api/stWebZyuserAllTemp/checkedDelete',
	deleteByUser:'/api/stWebZyuserAllTemp/deleteByUser',
	userSave:'/api/stWebZyuserAllTemp/userSave',
	userSave1:'/api/stWebZyuserAllTemp/userSave1',
	deleteZyUserTemp:'/api/stWebZyuserAllTemp/deleteZyUserTemp',
};
api.stWebSubprdAll= {
	getList:'/api/stWebSubprdAll/stWebSubprdAllList',
};
api.stWebSubprdAllTemp= {
	getList:'/api/stWebSubprdAllTemp/stWebSubprdAllTempList',
	getByDestLocCd:'/api/stWebSubprdAllTemp/getByDestLocCd',
	subPrdSave:'/api/stWebSubprdAllTemp/subPrdSave',
	subPrdSave1:'/api/stWebSubprdAllTemp/subPrdSave1',
	getList1:'/api/stWebSubprdAllTemp/stWebSubprdAllTempList1',
	deleteByUser:'/api/stWebSubprdAllTemp/deleteByUser',
	deleteSubPrdTemp:'/api/stWebSubprdAllTemp/deleteSubPrdTemp',
};
api.vStProdTypAll={
	getProdList:'/api/vStProdTypAll/getProdList',
	getInstNo:'/api/vStProdTypAll/getInstNo',
};

api.vSmLineAll={
	getLineList:'/api/vSmLineAll/getLineList',
};

api.vCmHinmoAll={
	getItmList:'/api/vCmHinmoAll/getItmList',
};
//销售预测登录
api.tForecastSalesMonth= {
	getList:'/api/tForecastSalesMonth/getList',
	getNewVer:'/api/tForecastSalesMonth/getNewVer',
	getVerList:'/api/tForecastSalesMonth/getVerList',
	monthExport:'/api/tForecastSalesMonth/monthExport',
	toImport:'/api/tForecastSalesMonth/toImport',
	toKcImport:'/api/tForecastSalesMonth/toKcImport',
	toMonthImport:'/api/tForecastSalesMonth/toMonthImport',
	salesSave:'/api/tForecastSalesMonth/salesSave',
	checkedDelete:'/api/tForecastSalesMonth/checkedDelete',
	getWriteOffList:'/api/tForecastSalesMonth/getWriteOffList',
};
//年度销售预测
api.tForecastSalesYear= {
	getList:'/api/tForecastSalesYear/getList',
	getNewVer:'/api/tForecastSalesYear/getNewVer',
	getVerList:'/api/tForecastSalesYear/getVerList',
	salesSave:'/api/tForecastSalesYear/salesSave',
	toExport:'/api/tForecastSalesYear/toExport',
	toImport:'/api/tForecastSalesYear/toImport',
	checkedDelete:'/api/tForecastSalesYear/checkedDelete',
	getYearByVerNo:'/api/tForecastSalesYear/getYearByVerNo',
};

api.VCustomer={
	getAll:'/api/vCustomer/getAll',
}

//代码维护
api.mCode= {
	//list:'/api/mCode',
	getList:'/api/mCode/mCodeList',
	//泛用：根据Type获取代码和名称
	codeByType:'/api/mCode/getCodeByType',
	codeTypeList:'/api/mCode/getCodeTypeList',
	checkedSave:'/api/mCode/checkedSave',
	getCodeNmByCode:'/api/mCode/getCodeNmByCode',

	//plantTypeList:'/api/mCode/getPlantTypeList',//车间
	lineTypeList:'/api/mCode/getLineTypeList',//产线
	//lineTypeList2:'/api/mCode/getLineTypeList2',//产线不包含AB线
	//packingTypeList:'/api/mCode/getPackingTypeList',//规格
	//taxTypeList:'/api/mCode/getTaxTypeList',//税别
	//packingBagList:'/api/mCode/getPackingBagList',//包装袋
	//palletTypeList:'/api/mCode/getPalletTypeList',//托盘
	scheduleTypeList:'/api/mCode/getScheduleList',//日程安排
	pauseReasonList:'/api/mCode/getPauseReasonList',//停机原因
	orderStatusList:'/api/mCode/getOrderStatusList',//aps销售订单状态
	planStatusList:'/api/mCode/getPlanStatusList',//生产计划状态
	yardCodeList:'/api/mCode/getYardCodeList',//码头
	orderTypeList:'/api/mCode/getOrderTypeList',//订单类型
	qcTypeList:'/api/mCode/getQcTypeList',//品质
	orderKindList:'/api/mCode/getOrderKindList',//需求类型
	planTypeList:'/api/mCode/getPlanTypeList',//计划类型
	provinceTypeList:'/api/mCode/getProvinceTypeList',//省份
	stockTypeList:'/api/mCode/getStockTypeList',//库存类型
	//warningTypeList:'/api/mCode/getWarningTypeList',//警告类型
	warehouseTypeList:'/api/mCode/getWarehouseTypeList',//仓库名称
	salesChannelList:'/api/mCode/getSalesChannelList',//分销渠道
	processRulesList:'/api/mCode/getProcessRulesList',//排程规则
	deliveryTermsList:'/api/mCode/getDeliveryTermsList',//成交方式
	kcImportCustomerList:'/api/mCode/getKcImportCustomerList',//KC导入对象
	pwdConfigList:'/api/mCode/getPwdConfigList',//密码维护系数
	customerTypeList:'/api/mCode/getCustomerTypeList',//客户类型
	saibanDigitList:'/api/mCode/getSaibanDigitList',//采番长度
	wmsOrderStatusList:'/api/mCode/getWmsOrderStatusList',//wms销售订单状态

	getPlantList:'/api/mCode/getPlantTypeList',
	getPackingList:'/api/mCode/getPackingTypeList',
	getTaxList:'/api/mCode/getTaxTypeList',
	getPackingBagList:'/api/mCode/getPackingBagList',
	getPalletList:'/api/mCode/getPalletTypeList',
	getlistSalesStatus:'/api/mCode/getlistSalesStatus',

	getListWarningType:'/api/mCode/getWarningTypeList',
	kcCheck:'/api/mCode/kcCheck',

	getInvTypList:'/api/mCode/getInvTypList',
};

//产线工作日历
api.mLineCalendar= {
	list:'/api/mLineCalendar',
	getList:'/api/mLineCalendar/mLineCalendarList',
	initYearCalendar:'/api/mLineCalendar/initYearCalendar',
	toSave:'/api/mLineCalendar/toSave',
	toCheck:'/api/mLineCalendar/toCheck',
	toExport:'/api/mLineCalendar/toExport',

};
//工厂日历
api.mFactoryCalendar= {
	list:'/api/mFactoryCalendar',
	getList:'/api/mFactoryCalendar/mFactoryCalendarList',
	toSave:'/api/mFactoryCalendar/toSave',
	initFactoryCalendar:'/api/mFactoryCalendar/initFactoryCalendar',
};
//品目基础信息
api.mGrade= {
	list:'/api/mGrade',
	getList:'/api/mGrade/mGradeList',
	checkedSave:'/api/mGrade/checkedSave',
	toImport:'/api/mGrade/toImport',
	toExport:'/api/mGrade/toExport',
	checkAndAdd:'/api/mGrade/checkAndAdd',
	checkAndEdit:'/api/mGrade/checkAndEdit',
	getAllGrade:'/api/mGrade/getAllGrade',
	isTryExistsCheck:'/api/mGrade/isTryExistsCheck',
};
//品目颜色批注维护
api.mGradeComment= {
	list:'/api/mGradeComment',
	getList:'/api/mGradeComment/mGradeCommentList',
	checkedDelete:'/api/mGradeComment/checkedDelete',
	checkedSave:'/api/mGradeComment/checkedSave',
	toImport:'/api/mGradeComment/toImport',
	toExport:'/api/mGradeComment/toExport',
};
//车间产能系数期间维护
api.mProductionRatio= {
	list:'/api/mProductionRatio',
	getList:'/api/mProductionRatio/mProductionRatioList',
	checkedDelete:'/api/mProductionRatio/checkedDelete',
	checkedSave:'/api/mProductionRatio/checkedSave',
};
//库存对应关系维护
api.mStockPackage= {
	list:'/api/mStockPackage',
	getList:'/api/mStockPackage/mStockPackageList',
	checkedDelete:'/api/mStockPackage/checkedDelete',
	checkedSave:'/api/mStockPackage/checkedSave',
};
//客户品名对应车间维护
api.mCustomerGradePlant= {
	list:'/api/mCustomerGradePlant',
	getList:'/api/mCustomerGradePlant/mCustomerGradePlantList',
	checkedDelete:'/api/mCustomerGradePlant/checkedDelete',
	checkedSave:'/api/mCustomerGradePlant/checkedSave',
	toImport:'/api/mCustomerGradePlant/toImport',
	toExport:'/api/mCustomerGradePlant/toExport',
};
//客户码头对应信息
api.mCustomerYard= {
	list:'/api/mCustomerYard',
	getList:'/api/mCustomerYard/mCustomerYardList',
	deleteRow:'/api/mCustomerYard/checkedDelete',
	planSave:'/api/mCustomerYard/checkedSave',
	PlanImport:'/api/mCustomerYard/toImport',
	PlanExport:'/api/mCustomerYard/toExport',
};
//客户基础信息
api.mCustomer= {
	list:'/api/mCustomer',
	getList:'/api/mCustomer/mCustomerList',
	planSave:'/api/mCustomer/checkedSave',
	PlanImport:'/api/mCustomer/toImport',
	PlanExport:'/api/mCustomer/toExport',
};
//产线主表
api.mPlantLine= {
	list:'/api/mPlantLine',
	getList:'/api/mPlantLine/mPlantLineList',
	planSave:'/api/mPlantLine/checkedSave',
	deleteRow:'/api/mPlantLine/checkedDelete'
};
//客户品目对应信息
api.mCustomerGrade= {
	list:'/api/mCustomerGrade',
	getList:'/api/mCustomerGrade/mCustomerGradeList',
	deleteRow:'/api/mCustomerGrade/checkedDelete',
	planSave:'/api/mCustomerGrade/checkedSave',
	toImport:'/api/mCustomerGrade/toImport',
	toExport:'/api/mCustomerGrade/toExport',
};
//年度生产计划调整
api.tYearPlan= {
	list:'/api/tYearPlan',
	getInitParams:'/api/tYearPlan/getInitParams',
	getList:'/api/tYearPlan/tYearPlanList',
	getStatus:'/api/tYearPlan/getStatus',
	checkedDelete:'/api/tYearPlan/checkedDelete',
	checkedSave:'/api/tYearPlan/checkedSave',
	yearPlanGenerate:'/api/tYearPlan/yearPlanGenerate',
	getDateByVerNo:'/api/tYearPlan/getDateByVerNo',
};
//理论期初库存
api.tPeriodStock= {
	list:'/api/tPeriodStock',
	getList:'/api/tPeriodStock/tPeriodStockList',
};
//实时库存查询
api.tRealtimeStock= {
	list:'/api/tRealtimeStock',
	getList:'/api/tRealtimeStock/tRealtimeStockList',
	checkedSave:'/api/tRealtimeStock/checkedSave',
	toExport:'/api/tRealtimeStock/toExport',
	updatePeriodStock:'/api/tRealtimeStock/updatePeriodStock',
	updatePeriodStockAll:'/api/tRealtimeStock/updatePeriodStockAll',
	isBeforeDate:'/api/tRealtimeStock/isBeforeDate',
};

//品目库存月度安全系数维护
api.mStockSafeRatio= {
	list:'/api/mStockSafeRatio',
	getList:'/api/mStockSafeRatio/mStockSafeRatioList',
	deleteRow:'/api/mStockSafeRatio/checkedDelete',
	planSave:'/api/mStockSafeRatio/checkedSave',
	PlanImport:'/api/mStockSafeRatio/toImport',
	PlanExport:'/api/mStockSafeRatio/toExport',
};

//处理日志查询
api.tLogPlan= {
	getList:'/api/tLogPlan/getList',
	getCount:'/api/tLogPlan/getCount',
	getVerList:'/api/tLogPlan/getVerList',
	checkSave:'/api/tLogPlan/checkSave',
	toExport:'/api/tLogPlan/toExport',
	toImport:'/api/tLogPlan/toImport',
	checkedDelete:'/api/tLogPlan/checkedDelete',
};
//生产计划排程
api.tProcess= {
	getPlantTabel:'/api/tProcess/getPlantTabel',
	checkIF:'/api/tProcess/checkIF',
	writeOff:'/api/tProcess/writeOff',
	monthProd:'/api/tProcess/monthProd',
	yearProd:'/api/tProcess/yearProd',
};

//排程规则
api.mGradeRule= {
	list:'/api/mGradeRule',
	getList:'/api/mGradeRule/mGradeRuleList',
	deleteRow:'/api/mGradeRule/checkedDelete',
	planSave:'/api/mGradeRule/checkedSave',
	PlanExport:'/api/mGradeRule/toExport',
};

//充填实绩查询
api.tRealtimeFillin= {
	list:'/api/tRealtimeFillin',
	getList:'/api/tRealtimeFillin/tRealtimeFillinList',
	checkedSave:'/api/tRealtimeFillin/checkedSave',
	getInstockDateForSearch:'/api/tRealtimeFillin/getInstockDateForSearch',
};

//需求计划
api.tProcessPlan= {
	list:'/api/tProcessPlan',
	getList:'/api/tProcessPlan/tProcessPlanList',
	toExport:'/api/tProcessPlan/toExport',
};

//生产计划调整
api.tMonthPlan= {
	list:'/api/tMonthPlan',
	getInitParams:'/api/tMonthPlan/getInitParams',
	getList:'/api/tMonthPlan/tMonthPlanList',
	checkedDelete:'/api/tMonthPlan/checkedDelete',
	checkedDeleteVerNo:'/api/tMonthPlan/checkedDeleteVerNo',
	checkedSave:'/api/tMonthPlan/checkedSave',
	planCheck:'/api/tMonthPlan/planCheck',
	planConfirm:'/api/tMonthPlan/planConfirm',
	planCancel:'/api/tMonthPlan/planCancel',
	planReEnable:'/api/tMonthPlan/planReEnable',
	getPlantNmByVerNo:'/api/tMonthPlan/getPlantNmByVerNo',
	toImport:'/api/tMonthPlan/toImport',
	toExport:'/api/tMonthPlan/toExport',
};
//盘点库存
api.tTanaStock= {
	list:'/api/tTanaStock',
	getList:'/api/tTanaStock/tTanaStockList',
	checkedDelete:'/api/tTanaStock/checkedDelete',
	toImport:'/api/tTanaStock/toImport',
};
//生产平衡表
api.vMonthPlan= {
	getAllList:'/api/vMonthPlan/getAllList',
	toExport:'/api/vMonthPlan/toExport',
};
//年度生产计划
api.vYearPlan= {
	getAllList:'/api/vYearPlan/getAllList',
	toExport:'/api/vYearPlan/toExport',
	getVer:'/api/vYearPlan/getVer',
};
//销售订单
api.vSalesOrder= {
	list:'/api/vSalesOrder',
	getList:'/api/vSalesOrder/vSalesOrderList',
	checkedSave:'/api/vSalesOrder/checkedSave',
	// getDetailInfo:'/api/vSalesOrder/OrderId',
	getDetailInfo:'/api/vSalesOrder/salesOrder'
};
//品目库存推移明细
api.tStockStatistics= {
	list:'/api/tStockStatistics',
	getList:'/api/tStockStatistics/tStockStatisticsList',
	updateExportData:'/api/tStockStatistics/updateExportData',
	getStatus:'/api/tStockStatistics/getStatus',
	getByVerNo:'/api/tStockStatistics/getByVerNo',
	toCheck:'/api/tStockStatistics/toCheck',
	checkedSave:'/api/tStockStatistics/checkedSave',
	toExport:'/api/tStockStatistics/toExport',
	getGradeByPlant:'/api/tStockStatistics/getGradeByPlant',
	getOtherFour:'/api/tStockStatistics/getOtherFour',
};

//甘特图
api.vGantt= {
	list:'/api/vGantt',
	getList:'/api/vGantt/vGanttList',
	toExport:'/api/vGantt/toExport',
};

//采购信息一览
api.tPurchase= {
	list:'/api/tPurchase',
	getList:'/api/tPurchase/tPurchaseList',
	beforePoDw:'/api/tPurchase/beforePoDw',
	toPoExport:'/api/tPurchase/toPoExport',
	beforeDelDw:'/api/tPurchase/beforeDelDw',
	toDelExport:'/api/tPurchase/toDelExport',
};

//评价信息管理
api.tEvaluate= {
	getList:'/api/tEvaluate/tEvaluateList',
	beforeEvaDw:'/api/tEvaluate/beforeEvaDw',
	toEvaExport:'/api/tEvaluate/toEvaExport',
	toSpplEvaUpload:'/api/tEvaluate/toSpplEvaUpload',
	beforeSpplEvaDw:'/api/tEvaluate/beforeSpplEvaDw',
	toSpplEvaExport:'/api/tEvaluate/toSpplEvaExport',
};

//询价信息管理
api.tInquiry= {
	getList:'/api/tInquiry/tInquiryList',
	//询价单
	beforeRqstDw:'/api/tInquiry/beforeRqstDw',
	toRqstExport:'/api/tInquiry/toRqstExport',
	//询价资料
	beforeRqstInfoDw:'/api/tInquiry/beforeRqstInfoDw',
	toRqstInfoExport:'/api/tInquiry/toRqstInfoExport',
	//报价单
	beforeQtnDw:'/api/tInquiry/beforeQtnDw',
	toQtnExport:'/api/tInquiry/toQtnExport',
	//报价附件
	beforeQtnInfoDw:'/api/tInquiry/beforeQtnInfoDw',
	toQtnInfoExport:'/api/tInquiry/toQtnInfoExport',

	//发邮件
	mailSend:'/api/tInquiry/mailSend',

	//跳转报价画面前检查
	beforeLinkCheck:'/api/tInquiry/beforeLinkCheck',
	//获取密令
	getSKey:'/api/tInquiry/getSKey',
	//验证密令
	verifySKey:'/api/tInquiry/verifySKey',
};

//报价信息管理
api.tQuotation= {
	findQuotation:'/api/tQuotation/findQuotation',
	checkedSave:'/api/tQuotation/checkedSave',
	refuseSave:'/api/tQuotation/refuseSave',
	toQtnUpload:'/api/tQuotation/toQtnUpload',
	toExcelImport:'/api/tQuotation/toExcelImport',

	deleteTmpJgfByUser:'/api/tTempJgf/deleteTmpJgfByUser',
	getJgfList:'/api/tQuotation/getJgfList',
	checkSaveJgf:'/api/tTempJgf/checkSaveJgf',

	deleteTmpMjfByUser:'/api/tTempMjf/deleteTmpMjfByUser',
	getMjfList:'/api/tQuotation/getMjfList',
	checkSaveMjf:'/api/tTempMjf/checkSaveMjf',
};

export default api;



// WEBPACK FOOTER //
// ./src/config/apiConfig.js